import { storeUFMap, StoreUF } from './constants';

// Agrupar lojas por UF
export const getStoresByUF = () => {
  const stores = new Map<StoreUF, string[]>();

  Object.entries(storeUFMap).forEach(([store, uf]) => {
    if (!stores.has(uf)) {
      stores.set(uf, []);
    }
    stores.get(uf)?.push(store);
  });

  return new Map([...stores.entries()].sort());
};

export const isUFSelected = (uf: StoreUF, selectedStores: string[]) => {
  const ufStores = Array.from(getStoresByUF().get(uf) || []);
  return ufStores.every(store => selectedStores.includes(store));
};

export const isUFPartiallySelected = (uf: StoreUF, selectedStores: string[]) => {
  const ufStores = Array.from(getStoresByUF().get(uf) || []);
  const selectedUFStores = ufStores.filter(store => selectedStores.includes(store));
  return selectedUFStores.length > 0 && selectedUFStores.length < ufStores.length;
};